import React, { ReactElement, ReactNode } from 'react';
import styles from '../SimpleCarousel.module.scss';

/**
 * Port notes: `GenericLazyString` (lazy i18n) is gone — titles are plain
 * strings/elements. The `eds-text-hs` / `eds-text-bm eds-text-color--ui-500`
 * global typography classes are baked into the CSS module (values from the eds
 * typography source).
 */
export const CarouselTitle: React.FunctionComponent<CarouselTitleProps> = (
    props,
) => {
    if (!props.children) {
        return null;
    }

    return (
        <div className={styles.titleBucket}>
            <div className={styles.title} data-testid="carousel-title">
                {props.children}
            </div>
            {props.subtitle ? (
                <div className={styles.subtitle}>{props.subtitle}</div>
            ) : null}
        </div>
    );
};

export const CarouselHeader: React.FunctionComponent<{
    children?: ReactNode;
}> = (props) => {
    return <div className={styles.header}>{props.children}</div>;
};

interface CarouselTitleProps {
    subtitle?: string | ReactElement;
    children?: ReactNode;
}
